
// @constants
const {
    OPEN_YOUNG_PACK,
    OPEN_YOUNG,
    PAYROLL_ACCOUNT,
    WELCOME_PAYROLL_ACCOUNT
} = require('constants/flagBasedFeatures');
const { OPEN_YOUNG_PACK_KEY } = require('constants/index.js');


const ACCOUNTS_PRODUCT_BANNERS = {
    '300805': {
        id: 'cta_nomina_open', //this is used to identify tag new
        featureTogglingKey: PAYROLL_ACCOUNT,
        title: 'banner300805-title',
        sidebarImgAlt: "banner300805-title",
        sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/cuenta_nomina.jpg',
        subtitle: 'banner300805-subtitle',
        advantages: [
            {
                text: 'banner300805-advantage01',
                icon: 'icon-0-euro'
            },
            {
                text: 'banner300805-advantage02',
                icon: 'icon-porcentaje'
            },
            {
                text: 'banner300805-advantage03',
                icon: 'icon-tarjetas'
            },
            {
                text: 'banner300805-advantage04',
                icon: 'icon-transferir'
            }
        ],
        link: '/myprofile/purchase/payroll-account'
    },
    '301101': {
        id: 'cta_ahorro_oy',
        featureTogglingKey: OPEN_YOUNG,
        title: 'banner301101-title',
        sidebarImgAlt: "banner301101-title",
        sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/cuenta_openyoung.jpg',
        subtitle: 'banner301101-subtitle',
        advantages: [
            {
                text: 'banner301101-advantage01',
                icon: 'icon-rentabilidad'
            },
            {
                text: 'banner301101-advantage02',
                icon: 'icon-ahorra-dinero'
            },
            {
                text: 'banner301101-advantage03',
                icon: 'icon-dinero'
            },
            {
                text: 'banner301101-advantage04',
                icon: 'icon-0-euro'
            }
        ],
        link: '/myprofile/purchase/junior-account'
    },
    '300': {
        id: 'cta_corriente_open',
        title: 'banner300-title',
        sidebarImgAlt: "banner300-title",
        sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/cuenta_corriente.jpg',
        subtitle: 'banner300-subtitle',
        advantages: [
            {
                text: 'banner300-advantage01',
                icon: 'icon-0-euro'
            },
            {
                text: 'banner300-advantage02',
                icon: 'icon-tarjetas'
            },
            {
                text: 'banner300-advantage03',
                icon: 'icon-transferir'
            },
            {
                text: 'banner300-advantage04',
                icon: 'icon-cajero'
            }
        ],
        link: '/myprofile/purchase/checking-account'
    },
    [OPEN_YOUNG_PACK_KEY]: {
        id: 'pack_open_young',
        featureTogglingKey: OPEN_YOUNG_PACK,
        title: 'bannerOpenYoungPack-bannerOpenYoungPack_accountTitle',
        sidebarImgAlt: 'bannerOpenYoungPack-bannerOpenYoungPack_accountTitle',
        sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/pack_openyoung.jpg',
        subtitle: 'bannerOpenYoungPack-bannerOpenYoungPack_accountSubtitle',
        advantages: [
            {
                text: 'bannerOpenYoungPack-bannerOpenYoungPack_accountAdvantage01',
                icon: 'icon-porcentaje'
            },
            {
                text: 'bannerOpenYoungPack-bannerOpenYoungPack_accountAdvantage02',
                icon: 'icon-ahorra-dinero'
            },
            {
                text: 'bannerOpenYoungPack-bannerOpenYoungPack_accountAdvantage03',
                icon: 'icon-candado'
            },
            {
                text: 'bannerOpenYoungPack-bannerOpenYoungPack_accountAdvantage04',
                icon: 'icon-0-euro'
            }
        ],
        link: '/myprofile/hire/pack/open-young'
    },
    'welcomePayrollAccount': {
        id: 'welcome_payroll_account',
        featureTogglingKey: WELCOME_PAYROLL_ACCOUNT,
        title: 'hireWelcomeAccount-hireWelcomeAccount_welcomeAccountPayrollBreadcrumbTitle',
        link: '/myprofile/hire/welcome-payroll-account'
    },
};

module.exports = ACCOUNTS_PRODUCT_BANNERS;
